import React, { Component } from 'react';
import MensajeF from '../Mensaje_Flotante/MensajeF';
import Footer from '../Principal/Footer';
import Header from '../Principal/Header';
import PreguntasFrecuentesProducto from '../Producto/PreguntasFrecuentesProducto';
import TipsProducto from '../Producto/TipsProducto';
import ServiciosVirtuales from '../Producto/ServiciosVirtuales';
import AperturaProducto from '../Producto/AperturaProducto';
import '../Principal/Responsive.css';
import { ProductosDetallesGET_ } from '../../services/WebAPI_Utrahuilca';
import { ProductosConfiguracion_, ProductosEncryptionKeyGET_, ProductosUrlDireccionGET_ } from '../../services/WebAPI_Utrahuilca';
import { MDBIcon } from 'mdbreact';
import { URLImgFront } from '../../config/URLDB';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

class ProductoDimanicoDigital extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Items: [],
            Beneficios: [],
            Requisitos: [],
            Caracteristicas: [],
            infoSelectData: [],
            infoDataProductos: [],
            stateBene: false,
            stateReq: false,
            stateTproduct: false,
            stateInfo: false,
            nombrelinea: '',
            activeTab: 'caracteristicas',
            stateInfoProductos: false,
            tipoproductucto: false,
            idtipopers: this.props.location.state.idtipopers //AJUSTE COOPV - RQTO AHORRO Y CDAT DIGITAL JPG NOV 2025
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        AOS.init({
            duration: 2000,
            easing: 'ease-in-out-cubic',
            once: true,

        });
        const id = parseInt(this.props.match.params.id);
        const dataProducunto = {
            tran: 8,
            idprodutra: id,
            descripcion: "NA",
            manejarutaimg: 0,
            rutaimg: "NA",
            usucrea: "NA",
            feccrea: Date,
            titulo: "NA",
            orden: 0,
            iditem: 999,
            estado: 1,
            idconfigitem: 0,
        }
        ProductosConfiguracion_(dataProducunto).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data.length >= 1) {
                        this.setState({
                            infoSelectData: response.data,
                            stateInfo: true
                        });
                        this.LoadData();
                    }
                } else {
                    this.setState({
                        stateInfo: false,
                    })
                }
            } catch (error) {
                console.log(error);
            }
        });

        const data = {
            tran: 7,
            idprodvtadet: 0,
            idprodutra: id,
            txtprodvtdet1: 'NA',
            txtprodvtdet2: 'NA',
            txtprodvtdet3: 'NA',
            rutaimgdetalle: 'NA',
            idtipovista: 0,
            infoadicional: 'NA',
            estado: 1,
            usucrea: 'NA',
        }

        ProductosDetallesGET_(data).then(response => {
            try {
                if (response.data.length > 0) {
                    if (response.data[0].idtipoprod === 2) {
                        this.setState({
                            tipoproductucto: true,
                            nombrelinea: 'Crédito'
                        })
                    } else {
                        this.setState({
                            tipoproductucto: false,
                            nombrelinea: 'Ahorros'
                        })
                    }
                    this.setState({
                        infoDataProductos: response.data,
                        txtprodvtdet1: response.data[0].txtprodvtdet1,
                        idtipoprod: response.data[0].idtipoprod,
                        txtprodvtdet2: response.data[0].txtprodvtdet2,
                        txtprodvtdet3: response.data[0].txtprodvtdet3,
                        rutaimgdetalle: response.data[0].rutaimgdetalle,
                        nombprodutra: response.data[0].nombprodutra,
                        idprodutra: response.data[0].idprodutra,
                        cargaritems: response.data[0].cargaritems,
                        idclasificprod: response.data[0].idclasificprod,
                        simula: response.data[0].simula,
                        prolinea: response.data[0].prolinea,
                        stateInfoProductos: true
                    });

                    if (this.state.idclasificprod === 2 ) { // PRODUCTOS DIGITAL

                        //RQTO. CRÉDITO DIGITAL FASE II
                        const param = this.state.idtipoprod === 2 ? 3 : 5;
                        const dataEncryptio = { parametros: `param=${param}&option=${this.state.prolinea}` };

                        ProductosEncryptionKeyGET_(dataEncryptio).then(response => {
                            if (response.data.length > 0) {
                                if (response.data.length >= 1) {
                                    this.setState({
                                        urlEncrypt: response.data,
                                    });
                                }
                            }
                        });
                        const dataUrlDireccion = {
                            tran: 5,
                            idurl:0,
                            direccionurl: "N/A",
                            identificador: "PaginaWeb",
                            estado: 1
                        }
                        ProductosUrlDireccionGET_(dataUrlDireccion).then(response => {
                            if (response.data.length > 0) {
                                if (response.data.length >= 1) {
                                    this.setState({
                                        urlDigital: response.data,
                                    });
                                }
                            }
                        });
                    }
                } else {
                    this.setState({
                        stateInfoProductos: false,
                    })
                }
            } catch (error) {
                console.log(error);
            }
        });
    }

    LoadData = () => {
        var addCaracteristicasN = [];
        var addBeneficiosN = [];
        var addRequisitosN = [];
        const dataJson = this.state.infoSelectData;
        var jsonnuevo = [];
        for (var i = 0; i < dataJson.length; i++) {
            for (var j = i; j < dataJson.length; j++) {
                if (dataJson[j].iditem === 1) {
                    addCaracteristicasN.push({ "descripcion": dataJson[j].descripcion, "rutaimg": dataJson[j].rutaimg });
                }

                if (dataJson[j].iditem === 2) {
                    addBeneficiosN.push({ "descripcion": dataJson[j].descripcion, "rutaimg": dataJson[j].rutaimg });
                }

                if (dataJson[j].iditem === 3) {
                    addRequisitosN.push({ "descripcion": dataJson[j].descripcion, "rutaimg": dataJson[j].rutaimg });
                }

                if (j === (dataJson.length - 1)) {
                    j = dataJson.length;
                    i = j - 1;
                    break;
                }
                else {
                    if (dataJson[j].idprodutra !== dataJson[j + 1].idprodutra) {
                        i = j;
                        j = dataJson.length;
                        break;
                    }
                }
            }
            addCaracteristicasN = new Set(addCaracteristicasN.map(JSON.stringify));
            let newaddCaracteristicas = Array.from(addCaracteristicasN).map(JSON.parse)

            addBeneficiosN = new Set(addBeneficiosN.map(JSON.stringify));
            let newaddBeneficios = Array.from(addBeneficiosN).map(JSON.parse);
            addRequisitosN = new Set(addRequisitosN.map(JSON.stringify));
            let newaddRequisitos = Array.from(addRequisitosN).map(JSON.parse);
            
            jsonnuevo.push(
                {
                    newaddCaracteristicas,
                    newaddBeneficios,
                    newaddRequisitos,
                }
            );
            addBeneficiosN = null;
            addRequisitosN = null;
            addCaracteristicasN = null;
        }

        this.setState({
            Beneficios: jsonnuevo[0].newaddBeneficios,
            Requisitos: jsonnuevo[0].newaddRequisitos,
            Caracteristicas: jsonnuevo[0].newaddCaracteristicas,
        })
    }

    handleTabChange = (tab) => {
        this.setState({ activeTab: tab });
    }

    render() {
        const { urlEncrypt, urlDigital, prolinea } = this.state;
        
        return (
            <React.Fragment>
                <Header id={this.state.idtipoprod} />
                <MensajeF />
                {this.state.stateInfo ? (
                    <React.Fragment>
                        <div className="bg-white productos_vista w-100" data-aos="fade-up" style={{ paddingTop: '120px', paddingBottom: '15px' }}>
                            <div className="container-fluid" >
                                <div className="breadcrumb-container py-2 px-3 d-flex flex-wrap align-items-center" style={{ fontSize: 'clamp(0.8rem, 2vw, 1.25rem)' }}>
                                    <MDBIcon icon="caret-right" className="mx-1" />
                                    <span>{this.state.idtipopers === 1 ? 'Personas' : 'Empresas'}</span>
                                    <MDBIcon icon="caret-right" className="mx-1" />
                                    <span data-aos="fade-up">{this.state.nombrelinea}</span>
                                    <MDBIcon icon="caret-right" className="mx-1" />
                                    <span data-aos="fade-up">{this.state.nombprodutra}</span>
                                    <hr style={{ background: 'rgb(240, 127, 0)', width: "98%" }} />
                                </div>
                            </div>

                            <div className="container-fluid pt-5">
                                <div className="row g-0">
                                    <div className="col-lg-6 col-12">
                                        <div className="product-info"
                                            style={{
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                height: '100%',
                                                textAlign: 'center'
                                            }}>
                                            <p className="font-weight-bold mb-3" data-aos="flip-left" style={{ fontSize: 'clamp(2rem, 2.5vw, 1.6rem)', color: '#3f8592' }}>
                                                {this.state.txtprodvtdet1}
                                            </p>
                                            <p className="mb-3" data-aos="flip-right" style={{ fontSize: 'clamp(2.5rem, 5vw, 4rem)', color: '#747373', fontWeight: 'bold' }}>
                                                {this.state.txtprodvtdet2}
                                            </p>
                                            <p className="font-weight-bold pb-3" data-aos="flip-up" style={{ fontSize: 'clamp(0.5rem, 2vw, 1rem)' }}>
                                                {this.state.txtprodvtdet3}
                                            </p>
                                            
                                            {(this.state.tipoproductucto && prolinea !== 49) && (
                                                <Link to="/Asesoria">
                                                    <span
                                                        data-aos="zoom-in"
                                                        className="px-4 py-2 mt-3 d-inline-block"
                                                        style={{
                                                            background: '#3f8592',
                                                            color: 'white',
                                                            fontWeight: 'bold',
                                                            borderRadius: '20px',
                                                            cursor: 'pointer',
                                                        }}
                                                    >
                                                        Asesoria Crédito
                                                    </span>
                                                </Link>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-5 col-12">
                                        <div
                                            className="product-card border-4 shadow overflow-hidden bg-white"
                                            style={{

                                                borderTopLeftRadius: '40px',
                                                borderTopRightRadius: '40px',
                                                borderBottomLeftRadius: '40px',
                                                borderBottomRightRadius: '40px',
                                                borderBottom: '10px',
                                            }}
                                        >
                                            <div className="position-relative" style={{ height: '300px' }}>
                                                <img data-aos="flip-right"
                                                    className="position-absolute m-auto object-contain p-4"
                                                    style={{
                                                        maxHeight: '100%',
                                                        maxWidth: '100%',
                                                        top: '0',
                                                        left: '0',
                                                        right: '0',
                                                        bottom: '0'
                                                    }}
                                                    src={`${URLImgFront}/assets${this.state.rutaimgdetalle}`}
                                                    alt={this.state.rutaimgdetalle}
                                                />

                                                {(this.state.idclasificprod === 2) && (  // this.state.idclasificprod === 2 SON PRODUCTOS DIGITALES
                                                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                                                        <span
                                                            style={{
                                                                position: 'absolute',
                                                                top: '10px',
                                                                right: '10px',
                                                                color: '#f07f00',
                                                                border: '2px solid #f07f00',
                                                                borderRadius: '20px',
                                                                padding: '5px 12px',
                                                                fontWeight: 'bold',
                                                                backgroundColor: 'transparent',
                                                                fontSize: '10px',
                                                            }}
                                                        >
                                                            100% Digital
                                                        </span>
                                                    </div>
                                                )}
                                            </div>

                                            <div data-aos="fade-up" className="d-flex justify-content-center border-bottom" style={{ cursor: 'pointer' }}>
                                                {['caracteristicas', 'beneficios', 'requisitos'].map(tab => (
                                                    <div
                                                        key={tab}
                                                        onClick={() => this.handleTabChange(tab)}
                                                        className={`px-2 px-md-3 pb-2 font-weight-bold text-center ${this.state.activeTab === tab
                                                            ? 'text-dark border-bottom border-warning'
                                                            : 'text-muted'
                                                            }`}
                                                        style={{
                                                            fontSize: 'clamp(0.75rem, 2vw, 1rem)',
                                                            borderBottomWidth: this.state.activeTab === tab ? '5px' : '0',
                                                            transition: 'all 0.2s ease-in-out',
                                                        }}
                                                    >
                                                        {tab.charAt(0).toUpperCase() + tab.slice(1)}
                                                    </div>
                                                ))}
                                            </div>

                                            <div style={{ scrollbarWidth: 'thin', scrollbarColor: '#f47216 #f1f1f1', overflowY: 'auto', height: '300px', width: '100%' }}>

                                                {this.state.activeTab === 'caracteristicas' && (this.state.Caracteristicas.length > 0 ? (
                                                    this.state.Caracteristicas.map((e, i) => (
                                                        <div key={i} className="col-12 py-3">
                                                            <div className="px-3 px-md-5">
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        style={{ width: '30px', height: '30px' }}
                                                                        className="img-fluid"
                                                                        src={`${URLImgFront}/assets${e.rutaimg}`}
                                                                        alt={e.rutaimg}
                                                                    />
                                                                    <div className="pl-3 text-left">
                                                                        <p className="text-justify mb-0" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
                                                                            {e.descripcion}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <>
                                                        <p className="text-center text-gray-500"><em>No hay información de caracteristicas disponibles.</em></p>
                                                    </>
                                                )
                                                )}

                                                {this.state.activeTab === 'beneficios' && (this.state.Beneficios.length > 0 ? (
                                                    this.state.Beneficios.map((e, i) => (
                                                        <div key={i} className="col-12 py-3">
                                                            <div className="px-3 px-md-5">
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        style={{ width: '30px', height: '30px' }}
                                                                        className="img-fluid"
                                                                        src={`${URLImgFront}/assets${e.rutaimg}`}
                                                                        alt={e.rutaimg}
                                                                    />
                                                                    <div className="pl-3 text-left">
                                                                        <p className="text-justify mb-0" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
                                                                            {e.descripcion}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <>
                                                        <p className="text-center text-gray-500"><em>No hay información de beneficios disponibles.</em></p>
                                                    </>
                                                )
                                                )}

                                                {this.state.activeTab === 'requisitos' && (this.state.Requisitos.length > 0 ? (
                                                    this.state.Requisitos.map((e, i) => (
                                                        <div data-aos="fade-up" key={i} className="col-12 py-3">
                                                            <div className="px-3 px-md-5">
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        style={{ width: '30px', height: '30px' }}
                                                                        className="img-fluid"
                                                                        src={`${URLImgFront}/assets${e.rutaimg}`}
                                                                        alt={e.rutaimg}
                                                                    />
                                                                    <div className="pl-3 text-left">
                                                                        <p className="text-justify mb-0" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
                                                                            {e.descripcion}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <>
                                                        <p className="text-center text-gray-500"><em>No hay información de requisitos disponibles.</em></p>
                                                    </>
                                                )
                                                )}
                                            </div>

                                            <div className="d-flex justify-content-center mb-2">

                                                {/*//1 SIMULA, 0 NO SIMULA,  idclasificprod === 1 -> TRADICIONAL*/}
                                                {((this.state.idtipoprod === 1) && (this.state.idclasificprod === 1) && (this.state.simula === 1)) && (  //idtipoprod === 1 Y simula === 1 PRODUCTOS DIGITALES AHORROS

                                                    <Link to={{ pathname: "/Simulador/Ahorros", state: { origen: this.state.prolinea } }}>
                                                        <span
                                                            className="px-4 py-2 mt-3 mb-3 d-inline-block"
                                                            style={{
                                                                background: '#3f8592',
                                                                color: 'white',
                                                                fontWeight: 'bold',
                                                                borderRadius: '20px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            Abrir Cuenta
                                                        </span>
                                                    </Link>
                                                )}

                                                {/*//1 SIMULA, 0 NO SIMULA*/}
                                                {((this.state.idtipoprod === 1) && (this.state.idclasificprod === 1) && (this.state.simula === 0)) && (  // this.state.idtipoprod === 1 -> PRODUCTOS AHORROS
                                                    <Link to="/Asesoria">
                                                        <span
                                                            className="px-4 py-2 mt-3 mb-3 d-inline-block"
                                                            style={{
                                                                background: '#3f8592',
                                                                color: 'white',
                                                                fontWeight: 'bold',
                                                                borderRadius: '20px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            Abrir Cuenta
                                                        </span>

                                                    </Link>
                                                )}

                                                {/*//1 SIMULA, 0 NO SIMULA, idclasificprod === 2 -> PRODUCTOS DIGITALES */}
                                                {((this.state.idtipoprod === 1) && (this.state.idclasificprod === 2) && (this.state.simula === 1)) ? (
                                                    <Link to={{ pathname: "/Simulador/Ahorros", state: { origen: this.state.prolinea } }}>
                                                        <span
                                                            className="px-4 py-2 mt-3 mb-3 d-inline-block"
                                                            style={{
                                                                background: '#3f8592',
                                                                color: 'white',
                                                                fontWeight: 'bold',
                                                                borderRadius: '20px',
                                                                cursor: 'pointer',
                                                            }}
                                                        >
                                                            Abrir Cuenta
                                                        </span>
                                                    </Link>
                                                ) : (
                                                    // PRODUCTOS DIGITALES QUE NO SE SIMULAN
                                                    ((this.state.idtipoprod === 1) && (this.state.idclasificprod === 2) && (this.state.simula === 0)) && (
                                                            /*<a href={urlDigital + urlEncrypt} target="_blank" rel="CREDITO DIGITAL" >*/
                                                            <a href={urlDigital + urlEncrypt} target="_blank" rel="noopener noreferrer" >
                                                            <span
                                                                className="px-4 py-2 mt-3 mb-3 d-inline-block"
                                                                style={{
                                                                    background: '#3f8592',
                                                                    color: 'white',
                                                                    fontWeight: 'bold',
                                                                    borderRadius: '20px',
                                                                    cursor: 'pointer',
                                                                }}
                                                            >
                                                                Abrir Cuenta
                                                            </span>
                                                        </a>
                                                    )
                                                )}

                                                {(this.state.idtipoprod === 2) && (  // this.state.idtipoprod === 2 -> PRODUCTOS DE CREDITO
                                                    <Link to={{ pathname: "/Simulador/Credito" }}>
                                                        <span
                                                            className="px-4 py-2 mt-3 mb-3 d-inline-block"
                                                            style={{
                                                                background: '#3f8592',
                                                                color: 'white',
                                                                fontWeight: 'bold',
                                                                borderRadius: '20px',
                                                                cursor: 'pointer',
                                                            }}
                                                            onClick={() => {
                                                                sessionStorage.setItem("idprodutra", this.props.match.params.id);
                                                            }}
                                                        >
                                                            Abrir Simulador
                                                        </span>
                                                    </Link>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </React.Fragment>
                ) : null
   
                }

                {/* idtipoprod === 1 Y simula === 1 PRODUCTOS DIGITALES AHORROS*/}
                {((this.state.idtipoprod === 1) && (this.state.idclasificprod === 2)) && (
                    <AperturaProducto idprodutra={this.state.idprodutra} />
                )}

                {this.state.idprodutra && (
                    <>
                        {/*AJUSTE TITULO - RQTO AHORRO Y CDAT DIGITAL JPG NOV 2025*/}
                        <TipsProducto idclasificprod={this.state.idclasificprod} idtipoprod={this.state.idtipoprod} idprodutra={this.state.idprodutra} />
                        <PreguntasFrecuentesProducto idprodutra={this.state.idprodutra} />
                        {/*AJUSTE COOPV - RQTO AHORRO Y CDAT DIGITAL JPG NOV 2025*/}
                        <ServiciosVirtuales idtipopers={this.state.idtipopers}/>
                    </>
                )}
                <Footer />
            </React.Fragment>
        );
    }
}

export default ProductoDimanicoDigital;